import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2026 The Spur Ventures. All rights reserved.</p>
        <p>University of Nebraska-Lincoln • Biological Systems Engineering</p>
      </div>
    </footer>
  );
};

export default Footer;